import isEmpty from 'lodash/isEmpty';
import { PageComponentWithCompanyTag } from '../../../hooks/issuers/useFetchMultiplePageComponents';
import { IssuerDto } from '../../../services/dtos/issuer/issuer.dto';
import { IssuerListDto } from '../../../services/dtos/issuer/issuerList.dto';
import { RelatedCompany } from './RelatedCompaniesWidget.types';

const companyComparator = (a: RelatedCompany, b: RelatedCompany) => a.displayName.localeCompare(b.displayName);

const filterCompaniesByIds = (companies: RelatedCompany[], ids: string[]): RelatedCompany[] => {
  return companies.filter((company) => {
    return company.companyTag && ids.includes(company.companyTag);
  });
};

export const sortCompanies = (
  companies: RelatedCompany[],
  focusCompanyIds: string[],
  secondaryCompanyIds: string[]
): RelatedCompany[] => {
  if (isEmpty(companies)) {
    return companies;
  }
  const focusCompanies = [...filterCompaniesByIds(companies, focusCompanyIds)].sort(companyComparator);
  const secondaryCompanies = [...filterCompaniesByIds(companies, secondaryCompanyIds)].sort(companyComparator);
  return [...focusCompanies, ...secondaryCompanies];
};

export const mapToRelatedCompanies = (
  companies: IssuerDto[] | undefined,
  pageComponents: PageComponentWithCompanyTag[] | undefined,
  issuers: IssuerListDto | undefined,
  displayBusinessDescriptions: boolean
): RelatedCompany[] => {
  if (displayBusinessDescriptions) {
    return (
      issuers?.results?.map((issuer) => {
        const component = pageComponents?.find((component) => component.companyTag === issuer.tagId);
        return {
          kind: 'BusinessDescription',
          companyTag: issuer.tagId,
          displayName: issuer.displayName,
          pageComponent: component,
        };
      }) ?? []
    );
  }
  return (
    companies?.map((company) => ({
      kind: 'Recommendation',
      companyTag: company.tagId,
      ...company,
    })) ?? []
  );
};
